import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../../../redux/authSlice";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  if (process.env.NODE_ENV === "development") {
    console.log("error++", error);
  }
  const [user, setUser] = useState({
    name: "",
    email: "",
    password: "",
    whatsappNumber: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!user.name.trim()) newErrors.name = "Name is required";
    if (!/^\d{10}$/.test(user.whatsappNumber))
      newErrors.whatsappNumber = "Invalid WhatsApp number (10 digits required)";
    if (!user.email.match(/^\S+@\S+\.\S+$/))
      newErrors.email = "Invalid email format";
    if (user.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      dispatch(registerUser(user)).then((res) => {
        if (res.error) {
          toast.error(res.error.message);
        } else {
          toast.success(res.payload.message);
          navigate("/login");
        }
      });
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Row className="p-4 shadow-lg rounded-4" style={{ width: '100%', maxWidth: '400px' }}>
        <Col md={12}>
          <h2 className="mb-4 text-center">Register</h2>
        </Col>
        <Col xxl={12} lg={12} md={12} sm={12}>
          {error && typeof error === "string" && <Alert variant="danger">{error}</Alert>}
          {error && typeof error === "object" && <Alert variant="danger">{error.message}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your name"
                value={user.name}
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter email"
                value={user.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Enter password"
                value={user.password}
                onChange={handleChange}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="text"
                name="whatsappNumber"
                placeholder="Enter WhatsApp Number"
                value={user.whatsappNumber}
                onChange={handleChange}
                isInvalid={!!errors.whatsappNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.whatsappNumber}
              </Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit" disabled={loading} className="w-100">
              {loading ? <Spinner animation="border" size="sm" /> : "Register"}
            </Button>
          </Form>
          <p className="mt-3 text-center">
            Already have an account? <Link to="/login">Login here</Link>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;














// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { registerUser } from "../../../redux/authSlice";

// const Register = () => {
//   const dispatch = useDispatch();
//   const { loading, error } = useSelector((state) => state.auth);
//   const [user, setUser] = useState({ name: "", email: "", password: "", whatsappNumber: "" });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(registerUser(user));
//   };

//   return (
//     <div>
//       <h2>Register</h2>
//       {error && <p style={{ color: "red" }}>{error}</p>}
//       <form onSubmit={handleSubmit}>
//         <input
//           type="text"
//           placeholder="Name"
//           value={user.name}
//           onChange={(e) => setUser({ ...user, name: e.target.value })}
//           required
//         />
//         <input
//           type="text"
//           placeholder="WhatsApp Number"
//           value={user.whatsappNumber}
//           onChange={(e) => setUser({ ...user, whatsappNumber: e.target.value })}
//           required
//         />
//         <input
//           type="email"
//           placeholder="Email"
//           value={user.email}
//           onChange={(e) => setUser({ ...user, email: e.target.value })}
//           required
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={user.password}
//           onChange={(e) => setUser({ ...user, password: e.target.value })}
//           required
//         />
//         <button type="submit" disabled={loading}>
//           {loading ? "Registering..." : "Register"}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Register;
